// استوديو الصفحات ومصمم المساحة.
export default {
  pageStudio: {
    title: "استوديو الصفحات",
    subtitle: "أنشئ صفحات كل مساحة مع المؤلف الذكي: شاشات لها وكلاؤها ومهامها وبياناتها، وتفحص قبل كل إصدار.",
    newPage: "صفحة جديدة",
    newPageHint: "تبدأ الصفحة من قالب، ويكفي وصف ما ينبغي أن تفعله ليعد المؤلف الذكي مسودتها للمراجعة.",
    createAndBuild: "إنشاء وصياغة بالذكاء الاصطناعي",
    created: "تم إنشاء {{name}}.",
    searchPlaceholder: "البحث في الصفحات أو المفاتيح أو الوسوم",
    emptyTitle: "لا توجد صفحات بعد",
    emptyBody: "يمكن إنشاء الصفحة الأولى هنا، أو تحميل حزمة مساحة بالأمر pnpm space:seed.",
    noMatch: "لا توجد صفحة تطابق هذه المرشحات.",
    personal: "شخصية",
    noSpace: "خارج المساحات",
    updated: "آخر تحديث {{when}}",
    notFound: "الصفحة غير موجودة",
    notFoundBody: "لا توجد صفحة بالمفتاح {{key}}، أو لا تملك صلاحية تأليفها.",
    draftCreated: "فتحت المسودة رقم {{version}}.",
    built: "اكتمل البناء.",
    buildFailed: "تعذر البناء: {{message}}",
    stageTitle: "إرسال {{name}} (النسخة {{version}}) للإطلاق؟",
    stageBody: "تفحص المسودة مجددا وتضاف إلى مجموعة تغييرات، وتصبح متاحة عند اعتماد المجموعة ونشرها.",
    stage: "إرسال للإطلاق",
    staged: "أضيفت إلى مجموعة التغييرات «{{title}}».",
    discardTitle: "تجاهل المسودة رقم {{version}}؟",
    discardBody: "تحذف تغييرات المسودة، وتبقى النسخة المنشورة كما هي.",
    discard: "تجاهل المسودة",
    discarded: "تم تجاهل المسودة.",
    runCheck: "فحص الصفحة",
    openInWorkspace: "فتح في المساعد الذكي",
    edit: "تعديل",
    build: "بناء",
    hideAuthor: "إخفاء المؤلف الذكي",
    showAuthor: "إظهار المؤلف الذكي",
    viewingOld: "أنت تعرض النسخة {{version}}، وهي للقراءة فقط.",
    publishedNote: "هذه النسخة منشورة وللقراءة فقط، ويفتح زر «تعديل» مسودة جديدة.",
    authorTitle: "المؤلف الذكي",
    authorDraftNote: "يعمل المؤلف الذكي على مسودة، فلا يتغير شيء لمستخدمي الصفحة حتى إطلاقها.",
    authorCan: {
      plan: "يخطط للتغيير ويحدد خطواته",
      edit: "يكتب الشيفرة والوكلاء والمهام ويصلحها",
      check: "يبني الصفحة ويفحصها بالعربية والإنجليزية",
      data: "يجد البيانات ويستوردها، ويطلب الحزم أو القدرات",
    },
    editWithAuthor: "فتح مسودة مع المؤلف الذكي",
    help: {
      title: "استوديو الصفحات",
      what: "الصفحات المخصصة هي شاشات المساحة: لوحات المؤشرات ومنصات العمل والسجلات وبطاقات الصفحة الرئيسية. كل صفحة مشروع React صغير له وكلاؤه ومهامه المجدولة وبياناته، ويعمل في بيئة معزولة لا يصل فيها إلا إلى القدرات التي يعلنها.",
      author: "يكتب المؤلف الذكي الشيفرة ويصلحها معك: يخطط ويعدل الملفات ويبني الصفحة ويفحصها بالعربية والإنجليزية ويستورد البيانات، ويطلب من فريق المنصة حزمة أو قدرة تحتاجها الصفحة.",
      release: "يفحص كل حفظ. وقبل الإطلاق تبنى الصفحة وتعرض مع فحص لإمكانية الوصول باللغتين، ويجري وكلاؤها اختباراتهم. ويمر الإطلاق عبر مجموعة تغييرات.",
    },
    galleryTabs: { pages: "الصفحات", suggestions: "الاقتراحات", requests: "الطلبات" },
    stats: {
      pages: "صفحات المساحات",
      pagesHint: "عدد المساحات: {{count}}",
      drafts: "مسودات مفتوحة",
      draftsHint: "تغييرات لم تطلق بعد",
      failing: "فحوص غير ناجحة",
      failingHint: "يلزم إصلاحها قبل الإطلاق التالي",
      personal: "صفحاتك الشخصية",
      personalHint: "أنشئت من المحادثة، ويمكن مشاركتها أو ترقيتها",
    },
    filters: { space: "المساحة", kind: "النوع", spacePages: "صفحات المساحات", personalPages: "الصفحات الشخصية" },
    fields: {
      title: "العنوان",
      titleAr: "العنوان بالعربية",
      key: "المفتاح",
      keyHint: "عنوان الصفحة في المساعد الذكي: /p/المفتاح.",
      keyInvalid: "يتكون المفتاح من 2 إلى 63 حرفا لاتينيا صغيرا أو رقما أو شرطة، ويبدأ بحرف.",
      space: "المساحة",
      spaceHint: "المساحة المالكة للصفحة، ويمكن لمساحات أخرى إضافتها لاحقا.",
      template: "البداية من",
      description: "ماذا ينبغي أن تفعل الصفحة؟",
      descriptionHint: "اختياري. يصوغ المؤلف الذكي الصفحة من هذا الوصف فور فتحها.",
      descriptionPlaceholder: "مثال: تتبع أعداد السياح حسب الإمارة كل ربع سنة، مع توقعات حتى 2031 ووكيل يشرح العوامل المؤثرة.",
    },
    templates: {
      dashboard: { name: "لوحة مؤشرات", description: "مؤشرات ومخطط وجدول لمجموعة بيانات واحدة، مع وكيل يجيب عن الأسئلة حولها." },
      workbench: { name: "منصة عمل للملف", description: "تبويب في الملف يعرض وقائعه وورقة عمل ووكيلا يصوغ فيها." },
      tracker: { name: "سجل متابعة", description: "سجل بمراحل، مثل ملفات السياسات أو الحملات أو الطلبات." },
      widget: { name: "بطاقة للصفحة الرئيسية", description: "بطاقة صغيرة للصفحة الرئيسية في المساحة." },
      blank: { name: "فارغة", description: "صفحة React فارغة مع مكتبة مكونات الصفحات." },
    },
    tabs: { preview: "المعاينة", code: "الشيفرة", data: "البيانات", agents: "الوكلاء", jobs: "المهام", versions: "النسخ", validation: "الفحوص", suggestions: "الاقتراحات", usage: "الاستخدام" },
    status: { Draft: "مسودة", InReview: "قيد المراجعة", Published: "منشورة", Retired: "متقاعدة" },
    check: { pass: "الفحوص ناجحة", warn: "تحذيرات", fail: "الفحوص غير ناجحة", skipped: "لم تفحص" },
    slots: { home: "الصفحة الرئيسية", nav: "القائمة", "work-tab": "تبويب في الملف", workbench: "منصة العمل", widget: "بطاقة" },
    severity: { error: "خطأ", warning: "تحذير", info: "ملاحظة" },
    origin: { personal: "أنشئت من المحادثة", suggestion: "تغيير مقترح", promoted: "رقيت من صفحة شخصية", repo: "من حزمة {{folder}}", import: "مستوردة", seed: "محملة من الحزمة" },
    preview: {
      navigates: "طلبت الصفحة فتح شاشة أخرى. تعمل الروابط داخل المساعد الذكي.",
      language: "اللغة",
      both: "كلتاهما",
      width: "العرض",
      desktop: "حاسوب",
      tablet: "جهاز لوحي",
      phone: "هاتف",
      slot: "تعرض بوصفها",
      space: "في المساحة",
      reload: "إعادة التحميل",
      draftNote: "تعاين المسودة رقم {{version}}، ولا يراها إلا المؤلفون حتى إطلاقها.",
      matter: "على الملف",
      noMatter: "تعرض تبويبات الملفات بيانات ملف بعينه، ولا توجد ملفات في هذه المساحة بعد، فتعرض الصفحة حالتها الفارغة حتى ينشأ ملف.",
    },
    code: {
      saved: "تم الحفظ.",
      savedWithErrors: "تم الحفظ مع أخطاء: {{count}}.",
      savedWithWarnings: "تم الحفظ مع تحذيرات: {{count}}.",
      deleteTitle: "حذف {{path}}؟",
      deleteBody: "يحذف الملف من المسودة، وتحتفظ به النسخ السابقة.",
      files: "الملفات: {{count}}",
      newFile: "ملف جديد",
      newFileHint: "مسار داخل المشروع، مثل src/components/Chart.tsx أو agents/analyst.md.",
      path: "المسار",
      exists: "يوجد ملف بهذا المسار.",
      readOnly: "للقراءة فقط",
      notePlaceholder: "ما الذي تغير (اختياري)",
      revert: "التراجع",
      saveAll: "حفظ الملفات ({{count}})",
      conflictTitle: "تغير هذا الملف منذ فتحته",
      conflictBody: "حفظ شخص آخر أو المؤلف الذكي نسخة أحدث، وسيستبدلها الحفظ الآن.",
      takeTheirs: "تحميل نسختهم",
      binary: "ملف ثنائي ({{type}})، ويستبدل برفع ملف جديد.",
    },
    data: {
      collections: "المجموعات",
      collectionsHint: "السجلات التي تحفظها الصفحة كما أعلنت في page.json، مع ما هو محفوظ الآن.",
      noCollections: "لا تعلن الصفحة أي مجموعات.",
      scope: { user: "لكل شخص", space: "لكل مساحة", shared: "لكل المساحات" },
      records: "السجلات: {{count}}",
      noRecords: "لم يحفظ شيء بعد.",
      retention: "تحفظ {{days}} يوما",
      datasets: "مجموعات البيانات",
      datasetsHint: "الجداول المستوردة لهذه الصفحة، بأعمدتها وعينة منها ومصدرها.",
      noDatasets: "لم تستورد أي مجموعات بيانات لهذه الصفحة.",
      origin: { upload: "رفع ملف", outreach: "تواصل", source: "مصدر", derived: "مشتقة", collector: "أداة جمع", function: "دالة", agent: "وكيل" },
      rows: "الصفوف: {{count}}",
      source: "المصدر",
      reads: "بيانات المنصة المقروءة",
      readsHint: "ما قرأته الصفحة من المنصة خلال آخر 30 يوما، حسب القدرة.",
      noReads: "لم تقرأ الصفحة بيانات من المنصة خلال آخر 30 يوما.",
      mocks: "بيانات العينة",
      mocksHint: "الملف mocks/datasets.json: البيانات التي تستخدمها الصفحة في المعاينة والفحوص.",
      noMocks: "لا توجد بيانات عينة للصفحة.",
    },
    agents: {
      emptyTitle: "لا يوجد وكلاء",
      emptyBody: "يضاف الوكيل في page.json، أو يطلب من المؤلف الذكي إضافته.",
      openFile: "فتح الملف",
      definition: "تعريف الوكيل",
      tools: "الأدوات",
      knowledge: "المعرفة",
      guardrails: "الضوابط",
      standard: "قياسية",
      budget: "الميزانية",
      tokensPerRun: "الرموز لكل تشغيل: {{count}}",
      month: "شهر",
      instructions: "التعليمات",
      evals: "الاختبارات ({{count}})",
      evalError: "تعذر تشغيل الاختبار.",
      evalResult: "نجح {{passed}} من {{total}} · اختبار الاختراق {{red}} من {{redTotal}}",
      notEvaluated: "لم يختبر بعد، ويختبر عند تشغيل الفحص الكامل.",
      clientTools: "أدوات تمنحها الصفحة لوكلائها",
      clientToolsHint: "إجراءات ينفذها الوكلاء داخل الصفحة المفتوحة، مثل تصفية مخطط.",
    },
    jobs: {
      emptyTitle: "لا توجد مهام",
      emptyBody: "تشغل المهام وكيلا أو دالة أو نموذجا وفق جدول أو عند وقوع حدث، وتعلن في page.json.",
      started: "بدأ التشغيل.",
      schedule: "الجدول {{cron}}",
      event: "عند {{event}}",
      manual: "تشغيل يدوي",
      runsAgent: "يشغل الوكيل {{agent}}",
      runsFunction: "يشغل الدالة {{name}}",
      runsModel: "يشغل النموذج {{name}}",
      draftNote: "تعمل المهام عند إطلاق الصفحة، وتظهر هنا حتى ذلك الحين دون أن تعمل.",
      notLive: "غير مفعلة",
      digest: "ملخص",
      owner: "المسؤول {{name}}",
      runNow: "تشغيل الآن",
      automation: "الأتمتة",
      next: "التالي {{when}}",
      last: "الأخير {{when}}",
      counts: "مرات التشغيل {{runs}}، والإخفاقات {{failures}}",
      noRuns: "لا توجد عمليات تشغيل بعد.",
      status: { Succeeded: "نجح", Failed: "أخفق", Skipped: "تم تخطيه", DryRun: "تشغيل تجريبي" },
    },
    versions: {
      restoreTitle: "استعادة النسخة {{version}}؟",
      restoreBody: "تنسخ ملفاته إلى المسودة (وتفتح مسودة عند الحاجة)، ولا يصبح شيء متاحا حتى تطلق المسودة.",
      restore: "استعادة",
      restoreNote: "استعيد من النسخة {{version}}",
      restored: "استعيدت النسخة {{version}} إلى المسودة رقم {{draft}}.",
      published: "نشر {{when}}",
      updated: "آخر تحديث {{when}}",
      files: "الملفات: {{count}}",
      backToNewest: "العودة إلى أحدث نسخة",
      compare: "مقارنة",
      newest: "الأحدث",
      compareTitle: "التغييرات من الإصدار {{from}} إلى {{to}}",
      compareHint: "الأسطر المحذوفة بالأحمر والمضافة بالأخضر.",
    },
    validation: {
      failed: "فحوص غير ناجحة: {{count}}.",
      warnings: "نجحت الفحوص مع تحذيرات: {{count}}.",
      passed: "نجحت جميع الفحوص.",
      projectIssues: "مشكلات في المشروع",
    },
    suggestions: {
      emptyTitle: "لا توجد اقتراحات",
      emptyBody: "يقترح المستخدمون التغييرات عبر «اقتراح تغيير» في المساعد الذكي، وتظهر هنا للمراجعة.",
      inboxEmpty: "لا شيء للمراجعة",
      inboxEmptyBody: "تظهر هنا التغييرات المقترحة والصفحات الشخصية المقدمة لمساحة.",
      open: "المفتوحة",
      withDecided: "مع ما تم البت فيه",
      noneWaiting: "لا شيء بانتظار المراجعة.",
      status: { Drafting: "قيد الصياغة", Ready: "جاهز", Submitted: "بانتظار المراجعة", Accepted: "مقبول", Declined: "مرفوض", Withdrawn: "مسحوب", Failed: "تعذر" },
      kind: { improve: "تغيير", promote: "إلى مساحة" },
      files: "الملفات: {{count}}",
      from: "من {{name}}، {{when}}",
      promoteInto: "إلى {{space}} بالمفتاح {{key}}",
      basedOn: "مبني على النسخة {{version}}",
      summary: "ما غيره المؤلف الذكي",
      changes: "التغييرات (الملفات: {{count}})",
      preview: "المعاينة",
      note: "ملاحظة لمقدم الطلب",
      noteHint: "ترسل مع قرارك.",
      accept: "قبول في المسودة",
      acceptPromote: "قبول في المساحة",
      decline: "رفض",
      acceptHint: "تدمج التغييرات في مسودة الصفحة، وتصبح متاحة عند إطلاق المسودة.",
      acceptPromoteHint: "تنشأ صفحة للمساحة من الصفحة الشخصية بوصفها مسودة، وتصبح متاحة عند إطلاقها.",
      accepted: "تم قبول الاقتراح.",
      declined: "تم رفض الاقتراح.",
      decided: "قرر {{name}}، {{when}}",
    },
    usage: {
      window: "الفترة",
      days: "آخر {{count}} يوم",
      days_one: "آخر يوم",
      days_two: "آخر يومين",
      days_few: "آخر {{count}} أيام",
      days_many: "آخر {{count}} يوما",
      days_other: "آخر {{count}} يوم",
      opens: "مرات الفتح",
      people: "الأشخاص",
      turns: "ردود الوكلاء",
      refused: "المرفوض: {{count}}",
      agentsUsed: "عدد الوكلاء: {{count}}",
      spend: "إنفاق النماذج",
      budget: "{{spent}} من {{budget}} هذا الشهر",
      noBudget: "بلا ميزانية شهرية",
      perDay: "الاستخدام اليومي",
      none: "لا استخدام في هذه الفترة.",
      byUser: "حسب الشخص",
      byUserHint: "من يستخدم الصفحة وكيف.",
      person: "الشخص",
      calls: "الاستدعاءات",
      capabilities: "القدرات المستدعاة",
      capabilitiesHint: "قدرات المنصة التي استدعتها الصفحة، وعدد المرفوض منها.",
      agents: "الوكلاء",
      bySpace: "حسب المساحة",
      kind: { open: "مرات الفتح", agent: "ردود الوكلاء", call: "الاستدعاءات", job: "تشغيل المهام", export: "التصدير", improve: "الاقتراحات", error: "الأخطاء" },
      outcome: { denied: "مرفوض", limited: "تجاوز الحد", error: "تعذر التنفيذ", invalid: "مدخلات غير صالحة" },
    },
    requests: {
      packages: "طلبات الحزم",
      packagesHint: "تستورد الصفحات الحزم من المخزن المعتمد فقط، ويطلب المؤلفون والمؤلف الذكي الحزم الجديدة هنا.",
      packageStatus: { Requested: "مطلوبة", Approved: "معتمدة", Rejected: "مرفوضة" },
      noPackages: "لا توجد طلبات حزم.",
      builderDown: "يتعذر الوصول إلى خدمة بناء الصفحات، فلم تحمل الحزم المعتمدة بعد.",
      capabilities: "طلبات القدرات",
      capabilitiesHint: "عندما لا تناسب أي قدرة في المنصة، يقدم المؤلف الذكي طلبا مع مسودة مواصفات لفريق المنصة.",
      requestStatus: { Open: "مفتوح", Accepted: "مقبول", Declined: "مرفوض", Delivered: "منجز" },
      noRequests: "لا توجد طلبات قدرات.",
      approved: "تم اعتماد {{name}}.",
      rejected: "تم رفض {{name}}.",
      vendor: "مضمنة",
      licence: "الترخيص",
      note: "ملاحظة",
      approve: "اعتماد",
      reject: "رفض",
      decided: "قرر {{name}}، {{when}}",
      resolved: "تم التعيين: {{status}}.",
      resolution: "القرار",
      resolutionPlaceholder: "ما الذي تقرر أو أنجز",
      mark: { Accepted: "قبول", Delivered: "منجز", Declined: "رفض" },
    },
  },
  spaceDesigner: {
    title: "تصميم المساحة",
    intro: "ما يراه المستخدمون في هذه المساحة داخل المساعد الذكي: صفحتها الرئيسية وقائمتها وحالات الاستخدام وتبويبات ملفاتها. تأتي الصفحات من استوديو الصفحات.",
    packNote: "جاء هذا التصميم من حزمة {{folder}}. بعد حفظه هنا لن تستبدله تحديثات الحزمة اللاحقة.",
    source: { repo: "من حزمة {{folder}}", generated: "قياسي إلى أن تحل محله حزمة أو يحفظ تعديل" },
    open: "فتح المساحة",
    reset: "التراجع عن التغييرات",
    save: "حفظ التصميم",
    saved: "تم حفظ تصميم المساحة.",
    notSaved: "لم يحفظ التصميم",
    issues: "مشكلات في التصميم المحفوظ",
    noPageList: "قائمة الصفحات غير متاحة لك، فتدخل مفاتيح الصفحات يدويا.",
    jsonHint: "يعدل التصميم هنا بصيغة JSON، ويحفظ بعد العودة إلى العرض المرئي.",
    textEn: "بالإنجليزية",
    textAr: "بالعربية",
    pageKey: "مفتاح الصفحة",
    choosePage: "اختيار صفحة",
    otherSlot: "غير مخصصة لهذا الموضع",
    missingPage: "صفحة غير موجودة",
    home: {
      title: "الصفحة الرئيسية",
      hint: "أقسام الصفحة الرئيسية للمساحة من الأعلى إلى الأسفل.",
      empty: "تعرض الصفحة الرئيسية الأقسام القياسية.",
      addPage: "صفحة",
      addUseCases: "حالات الاستخدام",
      addWidget: "بطاقة جاهزة",
      kind: { page: "صفحة", "use-cases": "حالات الاستخدام", builtin: "بطاقة جاهزة" },
      useCasesNote: "تعرض حالات استخدام المساحة ({{count}}).",
      width: "العرض",
      full: "عرض كامل",
      half: "نصف العرض",
      titlePlaceholder: "عنوان القسم (اختياري)",
    },
    nav: {
      title: "القائمة",
      hint: "قائمة المساحة: «العمل» لأدوات العمل اليومي، و«التحليل» لصفحات التحليل، و«الموارد» للمواد المرجعية.",
      sections: { work: "العمل", insight: "التحليل", resources: "الموارد" },
      addPage: "صفحة",
      addBuiltin: "شاشة",
      empty: "لا شيء هنا.",
      labelPlaceholder: "اسم في القائمة",
      icon: "الأيقونة",
      section: "القسم",
      group: "المجموعة",
      permission: "الصلاحية",
    },
    builtin: { home: "الرئيسية", chat: "المحادثة", inbox: "الوارد", matters: "الملفات", watchers: "المراقبات", artifacts: "المخرجات", knowledge: "المعرفة", evidence: "الأدلة", tracker: "المتابعة", library: "المكتبة" },
    matters: {
      title: "تبويبات الملفات",
      hint: "لكل دليل إجرائي، التبويبات التي يعرضها الملف مجمعة حسب المرحلة. ويمكن قصر المجموعة على حالات الملف التي تنطبق عليها.",
      customise: "تحديد التبويبات هنا",
      stage: "مفتاح المرحلة",
      stageLabel: "اسم المرحلة",
      states: "حالات الملف مفصولة بفواصل (فارغ للجميع)",
      tabLabel: "اسم التبويب (اختياري)",
      when: "فقط مع مفتاح القالب",
      whenHint: "يظهر التبويب فقط في الملفات التي يتضمن قالب حالة استخدامها هذا المفتاح، مثل sandbox.",
      addPageTab: "تبويب صفحة",
      addBuiltinTab: "تبويب جاهز",
      addStage: "مرحلة",
    },
    workbench: {
      title: "منصة العمل",
      hint: "صفحات تفتح بالحجم الكامل على الملف، من زر في رأسه.",
      empty: "لا توجد صفحات لمنصة العمل.",
    },
    mounts: {
      title: "صفحات من مساحات أخرى",
      hint: "صفحات تملكها مساحة أخرى ويمكن لمستخدمي هذه المساحة فتحها أيضا.",
      empty: "لم تضف صفحات.",
    },
    useCases: {
      title: "حالات الاستخدام",
      hint: "نقاط بداية جاهزة في الصفحة الرئيسية: تبدأ كل منها دليلا إجرائيا أو تفتح صفحة أو تسأل المساعد.",
      add: "حالة استخدام",
      empty: "لا توجد حالات استخدام.",
      ready: "جاهزة",
      proposed: "مقترحة",
      duration: "المدة",
      titlePlaceholder: "العنوان",
      descriptionPlaceholder: "ما الذي تفعله (اختياري)",
      producesPlaceholder: "ما الذي تنتجه (اختياري)",
      start: "تبدأ",
      startPlaybook: "دليلا إجرائيا",
      startPage: "صفحة",
      startPrompt: "سؤالا للمساعد",
      promptPlaceholder: "ما يسأل عنه المساعد",
      tags: "الوسوم مفصولة بفواصل",
    },
    grants: {
      title: "الصلاحيات الإضافية",
      hint: "قدرات إضافية تملكها الصفحات في هذه المساحة فوق ما تحصل عليه كل صفحة، مثل التواصل أو الكتابة في المنصة.",
      empty: "لا تملك أي صفحة صلاحيات إضافية.",
      placeholder: "الصلاحيات مفصولة بفواصل",
      add: "صلاحية",
    },
    look: {
      title: "المظهر والمصطلحات",
      hint: "سمة الصفحات في هذه المساحة، والمصطلحات التي تعيد تسمية الملفات والحالات.",
      theme: "السمة",
      defaultTheme: "السمة الافتراضية للمنصة",
      themes: { ncp: "ذهبي المنصة", seablue: "أزرق البحر", camel: "لون الجمل", aegreen: "أخضر الإمارات", slate: "رمادي" },
      vocabulary: "المصطلحات",
      standardWords: "المصطلحات القياسية",
    },
    usage: {
      title: "الاستخدام",
      hint: "كيف استخدمت صفحات المساحة.",
      pages: "الصفحات المستخدمة",
      page: "الصفحة",
      opens: "مرات الفتح",
      people: "الأشخاص",
      turns: "ردود الوكلاء",
      calls: "الاستدعاءات",
      errors: "الأخطاء",
      refused: "المرفوض",
      suggestions: "الاقتراحات",
    },
  },
} as const;
